import { defineMessages } from 'react-intl'

export default defineMessages({
    usermail: {
        defaultMessage: 'Email',
    },
    userpassword: {
        defaultMessage: 'Contraseña',
    },
})
